import Background from '../background';
import Footer from '../footer';
import Header from '../header';

export const Site = () => (
  <>
    <Header />
    <Background />
    <Footer />
  </>
);
